export function useIsMobile() {
	const isMobile = useState("isMobile", () => false);

	if (typeof window !== "undefined") {
		const updateIsMobile = () => {
			isMobile.value = window.innerWidth <= 768;
		};
		onMounted(() => {
			window.addEventListener("resize", updateIsMobile);
			updateIsMobile();
		});

		onUnmounted(() => {
			window.removeEventListener("resize", updateIsMobile);
		});
	}

	return {
		isMobile,
	};
}
